import axios from 'axios'

// 提示词模板管理（板块 / 模板 / 生成规则 / 用户生成结果 / LLM 接入配置）

// ─── 板块字典 ───
export const getPromptSlots = () => axios.get('/api/admin/prompt-slots')
export const createPromptSlot = (data) => axios.post('/api/admin/prompt-slots', data)
export const updatePromptSlot = (id, data) => axios.put(`/api/admin/prompt-slots/${id}`, data)
export const deletePromptSlot = (id) => axios.delete(`/api/admin/prompt-slots/${id}`)

// ─── 提示词模板 ───
export const getPromptTemplates = (params) => axios.get('/api/admin/prompt-templates', { params })
export const createPromptTemplate = (data) => axios.post('/api/admin/prompt-templates', data)
export const updatePromptTemplate = (id, data) => axios.put(`/api/admin/prompt-templates/${id}`, data)
export const deletePromptTemplate = (id) => axios.delete(`/api/admin/prompt-templates/${id}`)

// ─── 生成规则（联合保存兜底模板） ───
export const getGenerationConfig = (params) => axios.get('/api/admin/prompt-templates/generation-config', { params })
export const saveGenerationConfig = (data) => axios.put('/api/admin/prompt-templates/generation-config', data)

// ─── 用户生成结果与任务 ───
export const getPromptUserResults = (params) => axios.get('/api/admin/prompt-user', { params })
export const getPromptUserTasks = (params) => axios.get('/api/admin/prompt-user/tasks', { params })
export const regeneratePromptUser = (data) => axios.post('/api/admin/prompt-user/regenerate', data)
export const initPromptUserScan = () => axios.post('/api/admin/prompt-user/init')
export const getPromptInitProgress = (params) => axios.get('/api/admin/prompt-user/init-progress', { params })
export const getUserPersonalIdentity = (userId) => axios.get(`/api/admin/users/${userId}/personal-identity`)

// ─── LLM 接入配置 ───
export const getPromptLlmConfig = () => axios.get('/api/admin/prompt-llm-config')
export const savePromptLlmConfig = (data) => axios.put('/api/admin/prompt-llm-config', data)
export const testPromptLlmConfig = () => axios.post('/api/admin/prompt-llm-config/test')

// 用户展示接口：后端按当前登录身份随机返回一套，不在浏览器跨页面缓存。
export const getPublicPromptTemplates = (slots, domain = 0, context = {}) => axios.get('/api/prompt-templates', { params: { slots: slots.join(','), domain, pageKey: context.pageKey, templateSlug: context.templateSlug, section: context.section } })

export const getPromptPages = () => axios.get('/api/prompt-templates/pages')
